import { Skeleton } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import LottieDefault, { LottieProps } from 'react-lottie';
import { brandclub_colors } from '../../../colors';
import { ProductGrid } from '../../SearchResults/SearchResultsStyles';
import branclubloading from './brandclub_logo_load.json';
const Lottie = LottieDefault as React.ComponentType<LottieProps>;
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: branclubloading,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const ProductGridLoading = () => {
  return (
    <ProductGrid containerWidthOverride={false}>
      {Array.from(Array(10).keys()).map((i, idx) => {
        return (
          <Skeleton
            key={idx}
            variant="rectangular"
            width={'100%'}
            height={434}
            style={{ borderRadius: 12 }}
            sx={{ bgcolor: '#f6f8fa' }}
          />
        );
      })}
    </ProductGrid>
  );
};

const BrandclubLoading = ({
  type = 'star',
  lottieProps,
  width,
}: {
  type?: 'star' | 'productGrid' | 'collectionGrid';
  lottieProps?: LottieProps;
  width?: number;
}) => {
  if (type === 'productGrid') {
    return <ProductGridLoading />;
  }
  return (
    <div
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
      }}
    >
      {type === 'star' ? (
        <Lottie options={defaultOptions} width={width || 200} {...lottieProps} />
      ) : (
        <CircularProgress size={width || 100} sx={{ color: brandclub_colors.mainSeriesColor }} />
      )}
    </div>
  );
};

export default BrandclubLoading;
